<!-- nav -->


<!-- main app container -->
<div class="app-container">    
    <!-- preloader area start -->
<div class="preloader" id="preloader">
    <div class="preloader-inner">
        <div class="spinner">
            <div class="dot1"></div>
            <div class="dot2"></div>
        </div>
    </div>
  </div>
  <!-- preloader area end -->
  
  <!-- search popup start-->
  <div class="body-overlay" id="body-overlay"></div>
  <div class="td-search-popup" id="td-search-popup">
   
  </div>
  <!-- search popup end-->  
  
  <!-- navbar start -->
  <div *ngIf="showHeader" class="navbar-area navbar-area-1">
    <nav class="navbar navbar-expand-lg">
        <div class="container nav-container">            
            <div class="logo">
                <a class="main-logo" [routerLink]="['/']"><img src="/assets/img/logo.png" alt="img"></a>
            </div>
            <div class="nav-right-part nav-right-part-mobile">              
                <a *ngIf="!loggedIn" class="btn btn-white log-in" [routerLink]="['/login']">Login</a>                
                <a *ngIf="loggedIn" class="btn btn-white log-in" [routerLink]="['/account']">Account</a>
                <a *ngIf="loggedIn" class="btn btn-white log-in" href="/"  (click)="logout()">Logout</a>
            </div>                        
            <div class="nav-right-part nav-right-part-desktop">
                <a *ngIf="!loggedIn" class="btn btn-white log-in" [routerLink]="['/login']">Login</a>                
                <a *ngIf="loggedIn" class="btn btn-white log-in" [routerLink]="['/account']">My Account</a>
                <a *ngIf="loggedIn" class="btn btn-white log-in" href="/" (click)="logout()">Logout</a>
            </div>
        </div>
    </nav>
  </div>
  <!-- navbar end -->
    
        <router-outlet></router-outlet>
 <!-- footer area start -->
<footer *ngIf="showFooter" class="footer-area pd-top-140">
    <div class="container">                
        <div class="footer-bottom">
            <div class="row">
                <div class="col-md-6">
                    <div class="thumb">
                        <a [routerLink]="['/']"><img src="assets/img/logo.png" alt="img"></a>
                    </div>
                </div>
                <div class="col-md-6 text-md-right mt-3 mt-md-0 align-self-center">
                    <div *ngIf="isHome">Icons made by <a href="https://www.flaticon.com/authors/freepik" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a></div>
                </div>
            </div>
        </div>
    </div>
  </footer>
  <!-- footer area end -->
